// test142
(142 && 0);
